import { FormManagerMap, Form, CustomFormDataRetrieval, BrowserFormDataRetrival, FormManager, FormControl } from "./form-manager";
import { controlTag } from "./form-control-initializer";
import { Controller } from "@hotwired/stimulus";

export default class FormController extends Controller<HTMLFormElement> {

    static classes = ['button'];

    private static managerMap: FormManagerMap = {};
    private static unsaved = false; // Shared between all forms

    declare readonly buttonClass: string;
    declare readonly hasButtonClass: boolean;

    initialize(): void {
        controlTag.getAll(this.element.querySelectorAll('.ww-field__control'))
            .then(controls => this.initForm(controls));
    }

    private initForm(controls: FormControl[]) {
        let form = new Form(this.element, controls);
        let retrieval = this.element.hasAttribute('action') || 'async' in this.element.dataset ?
             new CustomFormDataRetrieval : new BrowserFormDataRetrival;
        let controller = new FormManager(form, FormController.managerMap, retrieval);
        let buttonClass = this.hasButtonClass ? this.buttonClass : 'ww-btn';
        this.element.querySelectorAll(`.${buttonClass}`).forEach((btnEl: HTMLButtonElement) => controller.addBtn(btnEl));
        form.onSubmit(this.getSubmitProcess(form, controller.onSubmit));
    }

    private getSubmitProcess(form: Form, submitFn: (e: Event) => Promise<any>) {
        let process = submitFn;
        if (form.warnsOfUnsavedChanges()) {
            // In case of multiple forms, the warning only catches the one last modified
            window.onbeforeunload = FormController.onBeforeUnload;
            form.addChangeListener(() => FormController.unsaved = true);
            form.el.addEventListener('success', () => { 
                FormController.unsaved = false
            });
        }
        return process;
    }

    private static onBeforeUnload = () => {
        if (FormController.unsaved) {
            return "If you leave this page, you will lose any unsaved changes.";
        }
        return null;
    }
}
